import { render, staticRenderFns } from "./percentage-field.vue?vue&type=template&id=2c6a1fbf"
import script from "./percentage-field.vue?vue&type=script&lang=js"
export * from "./percentage-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports